module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/user2-2cb74263534aefc00b61cba6faa16778.jpg";